import { useEffect, useState } from "react";
import Api from "../../utils/Api";
import {
  API_ROUTE_E_RETAIL_BUYER_STATUS_ASSIGNMENT,
  API_ROUTE_E_RETAIL_BUYER_STATUSES,
} from "../../routes";

export default function useBuyerStatus(auto = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(0);
  const [statuses, setStatuses] = useState([]);

  const getBuyerStatuses = () => {
    setIsLoading(true);

    Api.get(API_ROUTE_E_RETAIL_BUYER_STATUSES)
      .then((response) => {
        setStatuses(response.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const setBuyersStatus = (status, payload = {}) => {
    setIsLoading(true);

    return Api.patch(API_ROUTE_E_RETAIL_BUYER_STATUS_ASSIGNMENT, {
      ...payload,
      statusToAssign: status,
    })
      .then(() => {
        setSuccess(new Date().getTime());
        return Promise.resolve();
      })
      .catch((error) => {
        const err = error?.response?.data?.errors?.BuyerIds?.[0];
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!auto) {
      return;
    }
    getBuyerStatuses();
  }, [auto]);

  return {
    isLoading,
    error,
    success,
    statuses,
    getBuyerStatuses,
    setBuyersStatus,
    setError,
  };
}
